/**
 * @generated SignedSource<<0130240cc5cb3b0f01032ccbee4011c8>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "concreteType": "EdgeOfScheduleShift",
        "kind": "LinkedField",
        "name": "shiftEdge",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ScheduleShift",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    (v2 /*: any*/),
                    (v3 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v12 = [
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
        }
    ], v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v15 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "timestamp": "DESC"
            }
        }
    ], v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "byUser",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "employeeId",
                "storageKey": null
            },
            (v9 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    }, v20 = [
        (v6 /*: any*/),
        (v2 /*: any*/)
    ], v21 = [
        (v10 /*: any*/),
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isSchedulableEntity"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                (v2 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                }
            ],
            "type": "ISchedulableEntity",
            "abstractKey": "__isISchedulableEntity"
        },
        (v11 /*: any*/)
    ], v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newEnd",
        "storageKey": null
    }, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newStart",
        "storageKey": null
    }, v24 = [
        (v3 /*: any*/),
        (v13 /*: any*/),
        (v18 /*: any*/)
    ], v25 = {
        "alias": null,
        "args": null,
        "concreteType": "Break",
        "kind": "LinkedField",
        "name": "originalBreaks",
        "plural": true,
        "selections": (v24 /*: any*/),
        "storageKey": null
    }, v26 = {
        "alias": null,
        "args": null,
        "concreteType": "Break",
        "kind": "LinkedField",
        "name": "newBreaks",
        "plural": true,
        "selections": (v24 /*: any*/),
        "storageKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "originalEnd",
        "storageKey": null
    }, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "originalStart",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleShiftTimeStartMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleShiftTimePayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleShiftTime",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShiftHistoryTimeChange",
                            "kind": "LinkedField",
                            "name": "scheduleShiftHistoryTimeChangeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftHistoryTimeChange",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "scheduleShift",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleShift_shift"
                                                },
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "ScheduleShiftHistory_scheduleShift"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleShiftHistoryTimeChange_history"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditScheduleShiftTimeStartMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateScheduleShiftTimePayload",
                    "kind": "LinkedField",
                    "name": "updateScheduleShiftTime",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShiftHistoryTimeChange",
                            "kind": "LinkedField",
                            "name": "scheduleShiftHistoryTimeChangeEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShiftHistoryTimeChange",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShift",
                                            "kind": "LinkedField",
                                            "name": "scheduleShift",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "assignedEntity",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Asset",
                                                                    "kind": "LinkedField",
                                                                    "name": "asset",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v6 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/)
                                                            ],
                                                            "type": "SchedulableAsset",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v5 /*: any*/),
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableUser",
                                                            "abstractKey": null
                                                        },
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "assignedEntityId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "assignmentType",
                                                    "plural": false,
                                                    "selections": (v12 /*: any*/),
                                                    "storageKey": null
                                                },
                                                (v13 /*: any*/),
                                                (v3 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "isVacant",
                                                    "storageKey": null
                                                },
                                                (v14 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "event",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isWork",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAbsence",
                                                            "storageKey": null
                                                        },
                                                        (v6 /*: any*/),
                                                        (v5 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v15 /*: any*/),
                                                    "concreteType": "ScheduleShiftHistoryConnection",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftHistoryEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                (v18 /*: any*/),
                                                                                (v19 /*: any*/)
                                                                            ],
                                                                            "type": "IHaveScheduleShiftHistory",
                                                                            "abstractKey": "__isIHaveScheduleShiftHistory"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AssignmentType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newAssignmentType",
                                                                                    "plural": false,
                                                                                    "selections": (v12 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AssignmentType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "previousAssignmentType",
                                                                                    "plural": false,
                                                                                    "selections": (v12 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryAssignmentTypeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Event",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reasonEvent",
                                                                                    "plural": false,
                                                                                    "selections": (v20 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v19 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newAssignedEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v21 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "previouslyAssignedEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v21 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryAssigneeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v17 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "schedulableEntity",
                                                                                    "plural": false,
                                                                                    "selections": (v21 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v14 /*: any*/),
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryVacancyInterest",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v19 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                (v26 /*: any*/),
                                                                                (v27 /*: any*/),
                                                                                (v28 /*: any*/),
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryTimeChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Event",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "newEvent",
                                                                                    "plural": false,
                                                                                    "selections": (v20 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Event",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "previousEvent",
                                                                                    "plural": false,
                                                                                    "selections": (v20 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                (v19 /*: any*/),
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryEventChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "newStatus",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "previousStatus",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v19 /*: any*/),
                                                                                (v16 /*: any*/)
                                                                            ],
                                                                            "type": "ScheduleShiftHistoryStatusChange",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "cursor",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "totalCount",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "PageInfo",
                                                            "kind": "LinkedField",
                                                            "name": "pageInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "endCursor",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "hasNextPage",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "history(order:{\"timestamp\":\"DESC\"})"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v15 /*: any*/),
                                                    "filters": [
                                                        "order"
                                                    ],
                                                    "handle": "connection",
                                                    "key": "ScheduleShiftHistory_history",
                                                    "kind": "LinkedHandle",
                                                    "name": "history"
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v19 /*: any*/),
                                        (v22 /*: any*/),
                                        (v23 /*: any*/),
                                        (v25 /*: any*/),
                                        (v26 /*: any*/),
                                        (v27 /*: any*/),
                                        (v28 /*: any*/),
                                        (v16 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8e6c21b89831fbdf819012a287385636",
            "id": null,
            "metadata": {},
            "name": "EditScheduleShiftTimeStartMutation",
            "operationKind": "mutation",
            "text": "mutation EditScheduleShiftTimeStartMutation(\n  $model: UpdateScheduleShiftTimeRequestInput!\n) {\n  updateScheduleShiftTime(model: $model) {\n    shiftEdge {\n      node {\n        id\n        start\n      }\n    }\n    scheduleShiftHistoryTimeChangeEdge {\n      node {\n        id\n        scheduleShift {\n          ...ScheduleShift_shift\n          ...ScheduleShiftHistory_scheduleShift\n          id\n        }\n        ...ScheduleShiftHistoryTimeChange_history\n      }\n    }\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableEntity_schedulableEntity on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleShiftHistoryAssigneeChange_history on ScheduleShiftHistoryAssigneeChange {\n  id\n  reasonEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  newAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  previouslyAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryEventChange_history on ScheduleShiftHistoryEventChange {\n  id\n  newEvent {\n    name\n    id\n  }\n  previousEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryStatusChange_history on ScheduleShiftHistoryStatusChange {\n  id\n  newStatus\n  previousStatus\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryTimeChange_history on ScheduleShiftHistoryTimeChange {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  newEnd\n  newStart\n  originalBreaks {\n    start\n    end\n    type\n  }\n  newBreaks {\n    start\n    end\n    type\n  }\n  originalEnd\n  originalStart\n  timestamp\n}\n\nfragment ScheduleShiftHistoryVacancyInterest_history on ScheduleShiftHistoryVacancyInterest {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  description\n  schedulableEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  status\n  timestamp\n}\n\nfragment ScheduleShiftHistory_scheduleShift on ScheduleShift {\n  id\n  history(order: {timestamp: DESC}) {\n    edges {\n      node {\n        __typename\n        ... on IHaveScheduleShiftHistory {\n          __isIHaveScheduleShiftHistory: __typename\n          id\n          timestamp\n          description\n          type\n          byUser {\n            ...User_user\n            id\n          }\n        }\n        ... on ScheduleShiftHistoryAssignmentTypeChange {\n          newAssignmentType {\n            id\n            title\n          }\n          previousAssignmentType {\n            id\n            title\n          }\n        }\n        ...ScheduleShiftHistoryAssigneeChange_history\n        ...ScheduleShiftHistoryVacancyInterest_history\n        ...ScheduleShiftHistoryTimeChange_history\n        ...ScheduleShiftHistoryEventChange_history\n        ...ScheduleShiftHistoryStatusChange_history\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleShift_shift on ScheduleShift {\n  id\n  assignedEntity {\n    ... on SchedulableAsset {\n      id\n      ...SchedulableAsset_entity\n    }\n    ... on SchedulableUser {\n      id\n      ...SchedulableUser_entity\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignedEntityId\n  assignmentType {\n    id\n    title\n  }\n  end\n  start\n  isVacant\n  status\n  event {\n    id\n    isWork\n    isAbsence\n    name\n    color\n  }\n}\n\nfragment UserNameLabel_user on User {\n  employeeId\n  fullName\n}\n\nfragment User_user on User {\n  ...UserNameLabel_user\n  id\n}\n"
        }
    };
})();
node.hash = "0a5da4c924ebf63003bc14f7fef4785b";
export default node;
